<template>
  <div class="spotlight">
		<div class="bg">
			<div class="title">
				<p style="height: 55px;"></p>
				<!-- <img style="width:188px" src="../../assets/image/match/st-title.png" alt=""> -->
			</div>
			<div class="spt-box-list">
				<div class="spt-nav-list">
					<a href="javascript:void(0);"
						v-for="(item, index) in list"
						:key="index"
						@click="()=>onSelect(index)"
						class="li" :class="{'selected': index === activedIndex}">
						{{item.name}}
					</a>
				</div>
				<div class="spt-detail">
					<div class="text-detail" :class="[`img${activedIndex+1}`]"><p>{{list[activedIndex].text}}</p></div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
	name: "index",
	data() {
		return {
			activedIndex: 0,
			list: [
				{
					name: 'workshop工坊'.toUpperCase(),
					text: `本届大赛将举行“湾区共创设计工作坊 (workshop)”为特色的大赛全程的产学研合作工作。大
赛将整合东莞市企业、大湾区内高校和设计机构三方面的创新要素资源，以企业的实际设计需
求，举行共创设计，以设计工作坊的形式，推进产学研的深度合作，为企业设计攻关、项目落地和
大赛成果产业化提供保障。
`
				},
				{
					name: '数字化',
					text: `大赛联合字节跳动(飞书)、时谛智能(revofim)、PROFLY、国际体验设计大会(1XDC) 等数字化
资源助力，为参赛者提供免费的国产数字化管理工具、数字化设计软件、数字化协同工具以及数
宇化创新学习资源。
`
				},
				{
					name: '知识产权',
					text: `大赛将联合国内知名的知识产权机构，为所有参赛者提供免费的知识产权咨询和指导服务，为大
赛的优秀获奖项目提供知识产权申报资助服务。此外，为参赛单位提供知识产权交易、知识产权
金融、知识产权解化等资源的支持。`
				}
			]
		};
	},
	methods: {
		onSelect(index) {
			this.activedIndex = index;
		}
	},
}
</script>

<style lang="scss" scoped>
.spotlight {
	width:100%;
	height: 952px;
	// background: url('../../assets/image/match/spotlight-bg.jpg') no-repeat center top;
	.bg {
		height: 100%;
		// background: url('../../assets/image/match/spotlight-bg2.png') no-repeat center 146px;
	}
	.title {
		padding-top: 156px;
		text-align: center;
		margin-bottom: 122px;
	}
}
.spt-box-list {
	display: flex;align-items: center;justify-content: center;
}
.spt-nav-list {
	padding-top: 84px;
	height: 428px;width: 400px;
	// background: #d8c6ac;
	line-height: 81px;
	.li {display: block; width: 250px;position: relative;padding-left: 150px;color: #8f7d6c;margin-bottom: 48px;font-size: 16px;}
	.li::before {
		content: '';
		width: 73px;height: 100%;display: block;
		position: absolute;left: 70px;
		// background: url('../../assets/image/match/st-selected.png') no-repeat center center;
	}
	.li.selected {
		color: #1d0000;background: url('../../assets/image/match/spt-selected.png') no-repeat center center;
	}
}
.spt-detail {
	flex: 1;height: 364px;
	.text-detail {
		height: 100%;width: 100%;background-position: center center;
  	background-repeat: no-repeat;
		display: flex;align-items: center;justify-content: center;
	}
	.text-detail.img1 {
		background-image: url('../../assets/image/match/st-text-bg1.jpg');
	}
	.text-detail.img2 {
		background-image: url('../../assets/image/match/st-text-bg2.jpg');
	}
	.text-detail.img3 {
		background-image: url('../../assets/image/match/st-text-bg3.jpg');
	}
	p {width: 85%;text-indent: 25px;line-height: 34px;color: #fff;}
}
</style>



// WEBPACK FOOTER //
// src/components/Match/spotlight.vue